import * as yup from 'yup'

export const rhqSchema = yup
  .string()
  .matches(/^[A-Z]{2,}$/, '2_least_rhq_characters_ng')
  .min(2, '2_least_rhq_characters_ng')
  .max(5, '5_fewer_rhq_characters_ng')
  .required('enter_rhq_ng')

export const salesCompanySchema = yup
  .string()
  .max(50, '50_enter_sales_company_ng')
  .required('enter_sales_company_ng')
